import { ApplicationArea } from "../../../Lumber/ApplicationAreas";

/** The subset of the `useUserAuth` value these permission checks rely on. */
export interface EditTrialUserAuth {
	isApAdmin: boolean;
	currentClientId: string | null;
	hasApplicationArea: (applicationArea: string, clientId?: string | null) => boolean;
}

export function userCanEditTrial(userAuth: EditTrialUserAuth) {
	//-- ApAdmin can always edit no matter which client they are viewing
	if (userAuth.isApAdmin || userAuth.hasApplicationArea(ApplicationArea.TrialEdit, userAuth.currentClientId)) {
		return true;
	}

	return false;
}

export function userCanEditTrialName(userAuth: EditTrialUserAuth) {
	//-- ApAdmin can always edit no matter which client they are viewing
	if (userAuth.isApAdmin || userAuth.hasApplicationArea(ApplicationArea.TrialEdit, userAuth.currentClientId)) {
		return true;
	}

	return false;
}

export function userCanEditCompany(userAuth: EditTrialUserAuth, trialClientId: string | null) {
	//-- ApAdmin can always edit no matter which client they are viewing
	if (userAuth.isApAdmin || userAuth.hasApplicationArea(ApplicationArea.TrialEdit, userAuth.currentClientId)) {
		return true;
	}

	//-- User clientId isn't the client that created the trial
	if (userAuth.currentClientId !== trialClientId) {
		return false;
	}

	return false;
}

export function userCanEditTrialOwner(userAuth: EditTrialUserAuth) {
	//-- ApAdmin can always edit no matter which client they are viewing
	if (userAuth.isApAdmin || userAuth.hasApplicationArea(ApplicationArea.TrialEdit, userAuth.currentClientId)) {
		return true;
	}

	return false;
}

export function userCanEditPlantDate(userAuth: EditTrialUserAuth, trialClientId: string | null) {
	//-- ApAdmin can always edit no matter which client they are viewing
	if (userAuth.isApAdmin || userAuth.hasApplicationArea(ApplicationArea.TrialEdit, userAuth.currentClientId)) {
		return true;
	}

	//-- User clientId is the client that created the trial
	if (userAuth.currentClientId !== trialClientId) {
		return false;
	}

	return false;
}

export function userCanEditHarvestDate(userAuth: EditTrialUserAuth, trialClientId: string | null) {
	//-- ApAdmin can always edit no matter which client they are viewing
	if (userAuth.isApAdmin || userAuth.hasApplicationArea(ApplicationArea.TrialEdit, userAuth.currentClientId)) {
		return true;
	}

	//-- User clientId is the client that created the trial
	if (userAuth.currentClientId !== trialClientId) {
		return false;
	}

	return false;
}

export function userCanEditTreatments(userAuth: EditTrialUserAuth) {
	//-- ApAdmin can always edit no matter which client they are viewing
	if (userAuth.isApAdmin || userAuth.hasApplicationArea(ApplicationArea.TrialEdit, userAuth.currentClientId)) {
		return true;
	}

	return false;
}

export function userCanEditNotes(userAuth: EditTrialUserAuth) {
	//-- ApAdmin can always edit no matter which client they are viewing
	if (userAuth.isApAdmin || userAuth.hasApplicationArea(ApplicationArea.TrialEdit, userAuth.currentClientId)) {
		return true;
	}

	return false;
}
